module.exports = __webpack_public_path__ + "img/tiger-face.a4992ede.png";